export class ArticleUsageInfoPropertyDef {
  public static readonly ARTICLE_OFFSET: string = 'articleOffset';
  public static readonly ARTICLE_LENGTH: string = 'articleLength';
  public static readonly ARTICLE_HEIGHT: string = 'articleHeight';
  public static readonly ARTICLE_DEPTH: string = 'articleDepth';
  public static readonly ARTICLE_DEPTH_OFFSET: string = 'articleDepthOffset';

  public static readonly MAX_LENGTH: string = 'maxLength';

  public static readonly REMARKS: string = 'remarks';
  public static readonly REMARKS_INTERNAL: string = 'internalArticleRemark';
  public static readonly WIRE_LABEL: string = 'wireLabel';

  public static readonly BLOCKING_ZONE_TYPE: string = 'blockingZoneType';

  // building block properties
  public static readonly PART_OF_BUILDING_BLOCK: string = 'partOfBuildingBlock';
  public static readonly PART_OF_BUILDING_BLOCK_ON_RAIL: string = 'partOfBuildingBlockOnRail';

  // composite article properties
  public static readonly COMPOSITE_ARTICLE_USAGE_ID: string = 'compositeArticleUsageId';
  public static readonly COMPOSITE_ARTICLE_NO: string = 'compositeArticleNo';
  public static readonly COMPOSITE_ARTICLE_ID: string = 'compositeArticleId';
  public static readonly COMPOSITE_ARTICLE_VERSION: string = 'compositeArticleVersion';
  public static readonly COMPOSITE_GIVING_CONNECTION_NAME: string = 'compositeGivingConnectionName';
  public static readonly COMPOSITE_PART_EXCLUDED: string = 'compositePartExcluded';
  public static readonly COMPOSITE_PART_USAGE_ID: string = 'compositePartUsageId';

  public static readonly STRIPPED_COMPOSITE_ARTICLE_USAGE_ID: string = 'strippedCompositeArticleUsageId';
  public static readonly STRIPPED_COMPOSITE_ARTICLE_NO: string = 'strippedCompositeArticleNo';
  public static readonly STRIPPED_COMPOSITE_ARTICLE_ID: string = 'strippedCompositeArticleId';
  public static readonly STRIPPED_COMPOSITE_ARTICLE_VERSION: string = 'strippedCompositeArticleVersion';
  public static readonly STRIPPED_COMPOSITE_PART_USAGE_ID: string = 'strippedCompositePartUsageId';

  public static readonly ARTICLE_START_POSITION_BY_X: string = 'articleStartPosition';

  public static readonly ARTICLE_POSITION_X: string = 'positionX';
  public static readonly ARTICLE_POSITION_Y: string = 'positionY';
  public static readonly ARTICLE_POSITION_Z: string = 'positionZ';

  public static readonly ARTICLE_ROTATION_X: string = 'rotationX';
  public static readonly ARTICLE_ROTATION_Y: string = 'rotationY';
  public static readonly ARTICLE_ROTATION_Z: string = 'rotationZ';

  public static readonly HAS_DRILLINGHOLE_PRESET: string = 'hasDrillingholePreset';
  public static readonly DRILLINGHOLE_PRESET_DISTANCE: string = 'drillingholePresetDistance';
  public static readonly DRILLINGHOLE_PRESET_OFFSET: string = 'drillingholePresetOffset';

  public static readonly IS_STRETCHED: string = 'isStretched';
  public static readonly STRETCH_LENGTH_ON_BOTH_SIDES: string = 'stretchLength';

  public static readonly GROUP_LEAD_ARTICLE: string = 'groupLeadArticle';

  public static readonly ACTIVE_CONNECTION_SET_ID: string = 'activeConnectionSetId';

  public static readonly FORWARD_REFERENCE_ARTICLE_USAGE_IDS: string = 'forwardReferenceArticleUsageIds';

  public static readonly RELATIVE_PARENT_USAGE_ID: string = 'relativeParentUsageId';

  public static readonly LEADING_MEASUREMENT: string = 'leadingMeasurement';
  public static readonly MOUNTING_RAIL_OPEN_SIDE: string = 'mountingRailOpenSide';

  public static readonly SHEATHED_CABLE_TEXT1: string = 'sheathedCableText1';
  public static readonly SHEATHED_CABLE_TEXT2: string = 'sheathedCableText2';
  public static readonly SHEATHED_CABLE_TEXT3: string = 'sheathedCableText3';
  public static readonly OPEN_END_PREFIX: string = 'OPEN_END_';

  public static readonly BROKEN_PLUG_CONTACTS_NAMES: string = 'brokenPlugContactsNames';

  // cable properties
  public static readonly CABLE_TYPE: string = 'cableType';
  public static readonly STRAND_COUNT: string = 'strandCount';
  public static readonly COLOR_CABLE: string = 'colorCable';
  public static readonly CABLE_LENGTH: string = 'cableLength';
  public static readonly DESCRIPTION: string = 'description';

  public static readonly IS_FOIL_SHIELDING: string = 'isFoilShielding';
  public static readonly IS_PRINTED_SHEATHED_CABLE: string = 'isPrintedSheathedCable';

  // cable end properties
  public static readonly IS_REMOVE_BRAID: string = 'isRemoveBraid';
  public static readonly IS_CABLE_CORE_CUT: string = 'isCableCoreCut';

  public static readonly IS_SHRINK_TUBE: string = 'isShrinkTube';
  public static readonly LENGTH_ON_THE_CABLE_SHEATH: string = 'lengthOnTheCableSheath';
  public static readonly LENGTH_ON_THE_CABLE_STRANDS: string = 'lengthOnTheCableStrands';
  public static readonly TOTAL_LENGTH_STRANDS: string = 'totalLengthStrands';

  public static readonly IS_STRIPPED_AREA: string = 'isStrippedArea';
  public static readonly STRIPPED_AREA_LENGTH: string = 'strippedAreaLength';
  public static readonly STRIPPED_AREA_POSITION: string = 'strippedAreaPosition';

  public static readonly LENGTH_CABLE_IN_STRAIN_RELIEF: string = 'lengthCableInStrainRelief';
  public static readonly IS_UPPER_EXIT_ON_STRAIN_RELIEF: string = 'isUpperExitOnStrainRelief';

  public static readonly PLUG_PRINTING_COLOR: string = 'plugPrintingColor';

  // strand properties
  public static readonly COLOR_ID: string = 'colorId';
  public static readonly STRIP_LENGTH: string = 'stripLength';
  public static readonly STRAND_LENGTH: string = 'strandLength';
  public static readonly COMPACTING_LENGTH: string = 'compactingLength';
  public static readonly IS_FERRULES_SLEEVES: string = 'isFerrulesSleeves';
  public static readonly PLUG_CONNECTION: string = 'plugConnection';

  public static readonly IS_EMPTY_3D_MODEL: string = 'isEmpty3DModel';

  // custom article properties
  public static readonly CUSTOM_ARTICLE_NUMBER: string = 'customArticleNumber';
  public static readonly CUSTOM_ARTICLE_DESCRIPTION: string = 'customArticleDescription';
  public static readonly CUSTOM_IMAGE_USER_ID: string = 'userId';
  // nonpersistent property to store image hash
  public static readonly CUSTOM_ARTICLE_IMAGE_HASH: string = 'customArticleImageHash';

  public static readonly BOTTOM_ARTICLE_DEPTH: string = 'bottomArticleDepth';
  public static readonly TOP_ARTICLE_DEPTH: string = 'topArticleDepth';

  // busbar article prioperties
  public static readonly ARTICLE_ADDITIONAL_LENGTH_START: string = 'articleAdditionalLengthStart';
  public static readonly ARTICLE_ADDITIONAL_LENGTH_END: string = 'articleAdditionalLengthEnd';

  // CAE project properties
  public static readonly ARTICLE_NUMBER_WITH_PREFIX: string = 'caeArticleNumberWithPrefix';

  public static readonly CARRIER_BLOCK_GUID: string = 'carrierBlockGuid';
  public static readonly CAE_ITEM_NAME: string = 'caeItemName';
  public static readonly CAE_ITEM_STRUCTURE: string = 'caeItemStructure';
  public static readonly CAE_BRIDGE_CONNECTION_POINT: string = 'caeBridgeConnectionPoint';
  public static readonly CAE_BRIDGE_TERMINATION: string = 'caeBridgeTermination';
  public static readonly CAE_WIRE_TYPE: string = 'caeWireType';

  public static readonly CAE_RAIL_ROTATION = 'caeRailRotation';
  public static readonly CAE_RAIL_OFFSET_X = 'caeRailOffsetX';
  public static readonly CAE_RAIL_OFFSET_Y = 'caeRailOffsetY'
  public static readonly CAE_RAIL_OFFSET_Z = 'caeRailOffsetZ'

  public static readonly CAE_BRIDGE_OTHER_SIDE = 'caeBridgeOtherSide';

  public static readonly IS_LEADING_VALUE: string = 'isLeadingValue';

  public static readonly REMOVED_CODING_FINGER_ARTICLE_ID: string = 'removedCodingFingerArticleId';
  public static readonly REMOVED_CODING_FINGER_ARTICLE_VERSION: string = 'removedCodingFingerArticleVersion';
  public static readonly REMOVED_CODING_FINGER_COUNTER: string = 'removedCodingFingerCounter';
  public static readonly REMOVED_CODING_FINGER_COMPOSITE_PART_USAGE_ID: string = 'removedCodingFingerCompositePartUsageId';

  public static readonly IS_LABELING_CORRECTION_IGNORED: string = 'isLabelingCorrectionIgnored';
}
